import React from 'react';
import { LinkTargetValue } from '../../../../../constants/common.constants';
import { openText } from '../../../../../constants/common-labels.constants';
import { CopyButton } from '../../../../global/copy-button/copy-button';
import DefaultButton from '../../../../global/default-button/default-button';
import { OpenIcon } from '../../../../global/icons/icons';
import Text from '../../../../global/text/text';
import './website-builder-toolbar.scss';

type WebsiteBuilderToolbarProps = {
    hubName: string;
    hubUrl: string | null;
};

export const WebsiteBuilderToolbar = ({ hubName, hubUrl }: WebsiteBuilderToolbarProps) => {
    const handleOpen = () => {
        window.open(hubUrl, LinkTargetValue.BLANK, 'noopener, noreferrer');
    };

    return (
        <div className='website-builder-toolbar'>
            <div className='website-builder-toolbar__left'>
                <Text withEllipsis message={hubName} className='website-builder-toolbar__hub-name' />
                {hubUrl && (
                    <div className='website-builder-toolbar__actions'>
                        <CopyButton
                            withoutIcon
                            withCopyLink
                            copyValue={hubUrl}
                            className='website-builder-toolbar__copy-link'
                        />
                        <DefaultButton
                            text={openText()}
                            icon={OpenIcon}
                            onClick={handleOpen}
                            className='website-builder-toolbar__open'
                        />
                    </div>
                )}
            </div>
        </div>
    );
};
